export default "__VITE_ASSET__DHuBPwjq__"